module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$route.name === 'Login') ? _c('footer', {
    staticClass: "uk-container uk-width uk-flex uk-flex-wrap uk-flex-end uk-flex"
  }, [_c('div', {
    staticClass: "uk-width uk-text-center",
    domProps: {
      "textContent": _vm._s(_vm.config.footer_text)
    }
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f66530f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Login/app-footer.vue
// module id = 266
// module chunks = 1